// src/sections/Images.jsx
import React from "react";

const Images = ({ contenuti }) => {
  // Trasforma l'oggetto in array di sezioni
  const sections = Array.isArray(contenuti)
    ? contenuti
    : Object.values(contenuti);

  return (
    <>
      {sections.map((section) => {
        const { titolo_it, immagini_aggiuntive = [] } = section;
        const mode = titolo_it?.toLowerCase() === "full" ? "full" : "split";

        // se split, calcoliamo la larghezza di col per ciascuna immagine
        const cols = mode === "split" && immagini_aggiuntive.length > 0
          ? Math.floor(12 / immagini_aggiuntive.length)
          : 12;

        return (
          <div className="container mb-4 py-5" key={section.ID || titolo_it}>
            {mode === "full" ? (
              // Full mode: ogni immagine 100% di larghezza
              immagini_aggiuntive.map((img) => (
                <div key={img.ID} className="mb-3">
                  {img.titolo_it ? (
                    <a href={img.titolo_it}>
                      <img
                        src={img.immagine_path}
                        alt={img.descrizione || ""}
                        style={{ width: "100%", display: "block" }}
                      />
                    </a>
                  ) : (
                    <img
                      src={img.immagine_path}
                      alt={img.descrizione || ""}
                      style={{ width: "100%", display: "block" }}
                    />
                  )}
                </div>
              ))
            ) : (
              // Split mode: griglia bootstrap
              <div className="row">
                {immagini_aggiuntive.map((img) => (
                  <div className={`col-12 col-md-${cols}`} key={img.ID}>
                    {img.titolo_it ? (
                      <a href={img.titolo_it}>
                        <img
                          src={img.immagine_path}
                          alt={img.descrizione || ""}
                          className="img-fluid"
                        />
                      </a>
                    ) : (
                      <img
                        src={img.immagine_path}
                        alt={img.descrizione || ""}
                        className="img-fluid"
                      />
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        );
      })}
    </>
  );
};

export default Images;
